import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const getDashboardData = async () => {
  try {
    const token = getToken();
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/dashboard`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Failed to fetch Dashboard data:", error);
    throw error;
  }
};

const getYearlyTheftStatus = async (year) => {
  try {
    const token = getToken();
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/dashboard/yearly-theft?year=${year}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Failed to fetch yearly theft data:", error);
    throw error;
  }
};

export { getDashboardData, getYearlyTheftStatus };
